<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" v-bind="$attrs">
        {{ btnText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title">
        {{ modalTitle }}
      </v-card-title>

      <v-card-text>
        <v-divider class="pb-6"></v-divider>

        <file-upload-input :files.sync="files"></file-upload-input>

        <v-divider class="mt-6 pb-6"></v-divider>

        <v-row>
          <v-spacer></v-spacer>

          <v-col cols="auto">
            <v-btn depressed color="primary">Submit</v-btn>
            <v-btn @click="closeModal" depressed color="error" class="ml-2"
              >Cancel</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FileUploadInput from './FileUploadInput'

export default {
  name: 'FileUploadModal',
  props: {
    btnText: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      required: true
    }
  },
  components: {
    FileUploadInput
  },
  data: () => ({
    dialog: false,
    files: []
  }),
  methods: {
    closeModal() {
      this.files = []
      this.dialog = false
    }
  }
}
</script>
